export default __webpack_public_path__ + "static/cafe_36019-8905c92149c54a2dcb9dc350d411aa70.png";